import constants from '@/app-configs/constants'

export default [
  {
    path: '/invoices/create',
    name: 'create_invoice',
    component: () => import('@/views/invoicing/CreateInvoice.vue'),
    meta: {
      title: 'Create Invoice',
      action: constants.action.permissionAllowInvoicing,
      resource: constants.resource.invoicing,
    },
  },
  {
    path: '/invoices',
    name: 'invoices-list',
    component: () => import('@/views/invoicing/List.vue'),
    meta: {
      pageTitle: 'DEBTIA_INVOICES',
      breadcrumb: [
        {
          text: 'DEBTIA_INVOICES',
          active: true,
        },
      ],
      action: constants.action.permissionAllowInvoicing,
      resource: constants.resource.invoicing,
    },
  },
  {
    path: '/invoice/details/:id',
    name: '/invoice-details',
    component: () => import('@/views/invoicing/Details.vue'),
    meta: {
      pageTitle: 'DEBTIA_INVOICE_DETAILS',
      breadcrumb: [
        {
          text: 'DEBTIA_INVOICE_DETAILS',
          active: true,
        },
      ],
      action: constants.action.permissionAllowInvoicing,
      resource: constants.resource.invoicing,
    },
  },
]
